import Vue from 'vue'
import { mapState } from 'vuex'

import { IPanel } from '@/types/view'

import { SelectOption } from './types'
import { Tag } from '@/types/tag'

export default Vue.extend({
  props: {
    value: Object,
  },
  data() {
    return {
      model: {
        attributes: {
          labelText: 'Label',
          labelStyle: {},
          unitText: 'Unit',
          unitStyle: {},
          valuePrecision: 2,
          valueStyle: {},
          tag: '',
          valueMin: 0,
          valueMax: 100,
        },
        // eslint-disable-next-line
        query: [] as any[],
      } as IPanel,
    }
  },
  computed: {
    ...mapState('tag', { tags: 'items' }),

    optsTag(): SelectOption[] {
      return Object.keys(this.tags).map((uid) => {
        return { value: uid, text: this.tags[uid].name }
      })
    },
    displayValue(): string | number {
      if (this.model.attributes.tag) {
        const tag: Tag = this.tags[this.model.attributes.tag]
        if (tag) {
          if (typeof tag.value == 'number') {
            if (tag.value < this.model.attributes.valueMin) {
              return this.model.attributes.valueMin.toFixed(
                this.model.attributes.valuePrecision
              )
            }
            if (tag.value > this.model.attributes.valueMax) {
              return this.model.attributes.valueMax.toFixed(
                this.model.attributes.valuePrecision
              )
            }

            return tag.value.toFixed(this.model.attributes.valuePrecision)
          }

          return tag.value
        }
      }
      return '###.##'
    },
  },
  methods: {
    parseInput() {
      this.model = {
        ...this.value,
        // query: this.value.query.map((q: string) => JSON.parse(q)),
      }
    },
    parseModel(): IPanel {
      return {
        ...this.model,
        // query: this.model.query.map((q) => JSON.stringify(q)),
      }
    },
  },
  watch: {
    value: {
      deep: true,
      // eslint-disable-next-line
      handler: function(val: any) {
        const parsedModel = this.parseModel()
        if (JSON.stringify(val) != JSON.stringify(parsedModel)) {
          // this.model = this.value
          this.parseInput()
        }
      },
    },
    model: {
      deep: true,
      handler: function(val) {
        if (JSON.stringify(val) != JSON.stringify(this.value)) {
          this.$emit('input', this.parseModel())
        }
      },
    },
  },

  created() {
    this.parseInput()
  },
})
